window.navigator = window.navigator || {};
window.navigator.sendBeacon = function (url, data) {
    const options = {
        method: 'POST',
        body: data,
        keepalive: true
    };

    try {
        fetch(url, options).catch(() => { });
        return true;
    } catch (e) {
        return false;
    }
};

export default {};